const flights = {
  flight: "フライト", // translated
  flights: "フライト", // translated
  originDepartureDate: "出発", // translated
  destinationDepartureDate: "戻る", // translated
  outbound: "往路", // translated
  inbound: "インバウンド", // translated
  travelTime: "移動時間", // translated
  selected: "選択された", // translated
  select: "選択する", // translated
  airline: "航空会社", // translated
  directFlight: "直行便", // translated
  baggage: "手荷物", // translated
  stops: "停留所", // translated
  nonStop: "ノンストップ", // translated
  oneStopMax: "ワンストップマックス", // translated
  twoStopsMax: "最大2ストップ", // translated
  anyStops: "どの停留所でも", // translated
  smallBaggage: "小さな荷物", // translated
  bigBaggage: "大きな荷物", // translated
  smallAndBigBaggage: "小さい荷物も大きな荷物も", // translated
  outboundStops: "下り停留所", // translated
  inboundStops: "上り停留所", // translated
  selectAirline: "航空会社を選択してください", // translated
  baggageOption: "手荷物オプション", // translated
  outboundDepartureAfter: "往路出発後", // translated
  outboundArrivalAfter: "往路到着後", // translated
  inboundDepartureAfter: "復路出発後", // translated
  inboundArrivalTimeAfter: "到着後", // translated
  flightClass: "フライトクラス", // translated
  outboundDepAfter: "出発後", // translated
  outboundArrivalAfrer: "到着後", // translated
  inboundDepAfter: "出発後", // translated
  inboundArrivalAfter: "到着後", // translated
  airlines: "航空会社", // translated
  lessThan: "未満", // translated
  layover: "乗り継ぎ", // translated
  duration: "間隔", // translated
  economy: "エコノミー", // translated
  business: "ビジネス", // translated
  with: "と", // translated
  without: "それなし", // translated
  twoOrMore: "2つ以上", // translated
  departure: "出発", // translated
  return: "戻る", // translated
  submit: "提出する", // translated
  priceLessThan: "以下の価格", // translated
  durationLessThan: "持続時間未満", // translated
  layoverLessThan: "乗り継ぎ時間未満", // translated
  noLayover: "乗り継ぎなし", // translated
  durationLowestFirst: "期間 (短い順)", // translated
  durationHighestFirst: "期間 (長い順)", // translated
  idType: "IDの種類", // translated
  idPassportCode: "ID/パスポート番号", // translated
  expirationDate: "有効期限", // translated
  frequentFlyerNumber: "マイレージ番号", // translated
  frequentFlyerAirline: "マイレージ航空会社", // translated
  dateOfBirth: "生年月日", // translated
  infant: "幼児", // translated
  phone: "電話", // translated
  title: "タイトル", // translated
  noLuggageIncluded: "荷物は含まれません", // translated
  includesLuggage: "荷物を含む", // translated
  outboundFlight: "アウトバウンド飛行", // translated
  inboundFlight: "復路", // translated
  flightNumber: "フライトナンバー", // translated
  flightNumbers: "便名", // translated
  cabinClassType: "キャビンクラスタイプ", // translated
  aircraftType: "航空機の種類", // translated
  airlineName: "航空会社名", // translated
  no: "いいえ", // translated
  yes: "はい", // translated
  anyFlights: "すべてのフライト", // translated
  oneStop: "ワンストップ", // translated
  direct: "直接", // translated
  directFlights: "直行便", // translated
  all: "全て", // translated
  first: "ファースト", // translated
  premiumEconomy: "プレミアムエコノミー", // translated
  withBaggageOnly: "手荷物のみの場合", // translated
  oneWay: "片道", // translated
  roundTrip: "往復", // translated
  withBaggage: "手荷物あり", // translated
  noBaggage: "手荷物なし", // translated
  requiredFields: "必須フィールド", // translated
  nonRequiredFields: "必須ではないフィールド", // translated
  cabinClass: "キャビンクラス", // translated
  brandName: "ブランド名", // translated
  performNewSearch: "新しい検索を実行する", // translated
  outboundDeparture: "往路出発", // translated
  inboundDeparture: "復路出発", // translated
  created: "作成した", // translated
  freeCancellationAvailable: "無料キャンセル可能", // translated
  freeCancellationDeadline: "無料キャンセル期限", // translated
  externalReference: "外部リファレンス", // translated
  outboundflightNumber: "往路便名", // translated
  inboundflightNumber: "到着便の便名", // translated
  arrival: "到着", // translated
  noBaggagePreference: "手荷物指定なし", // translated
  aircraft: "Aircraft",
  noClassPreference: "クラス指定なし", // translated
  class: "Class",
  originAirport: "出発地 空港",
};

export default flights;
